<template>
  <div>
    <el-input :size="size" placeholder="请选择字典" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSelect">选择字典</td>
        </tr>
      </table>
    </el-input>
    <dict-select-dialog ref="dictSelectDialog" @save="onSave"></dict-select-dialog>
  </div>
</template>

<script>
import DictSelectDialog from '../model/DictSelectDialog'

export default {
  name: 'dict-select-button',
  components: {
    DictSelectDialog
  },
  props: {
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        this.text = !val ? '' : JSON.parse(val).name
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSelect () {
      this.$refs.dictSelectDialog.open()
    },
    onSave (dict) {
      this.property.value = JSON.stringify(dict)
      this.text = dict.name
      this.$emit('change')
    }
  }
}
</script>
